const FeatureFlag = ({ enabled, children }: any) => {
  return enabled ? <>{children}</> : null;
};

export default FeatureFlag;
